import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DatumList from './Datum/DatumList';
import { getPendingUnstampRequests, getResolvedUnstampRequests } from '../../../api/DatumManipulation';
import { getDatum_One } from '../../../api/DatumManipulation';
import { getUser } from '../../../api/UserRequest';
import { TbRubberStampOff } from 'react-icons/tb';
import { VscPassFilled } from 'react-icons/vsc';

const UnstampFeed = ({ setMainContent, activeTab }) => {
    const { user } = useSelector((state) => state.authReducer.authData);
    const { deletedDatumId } = useSelector((state) => state.modalReducer);
    const [pendingData, setPendingData] = useState([]);
    const [resolvedData, setResolvedData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!deletedDatumId) return;
        setPendingData(prev => prev.filter(d => d._id !== deletedDatumId));
        setResolvedData(prev => prev.filter(d => d._id !== deletedDatumId));
    }, [deletedDatumId]);

    const fetchPending = async () => {
        setLoading(true);
        try {
            const res = await getPendingUnstampRequests(user._id);
            const validData = res.data.filter(datum => datum !== null && datum._id);
            setPendingData(validData);
        } catch (error) {
            console.error('Error fetching pending unstamp requests:', error);
        }
        setLoading(false);
    };

    const fetchResolved = async () => {
        setLoading(true);
        try {
            const res = await getResolvedUnstampRequests(user._id);
            const validData = res.data.filter(datum => datum !== null && datum._id);
            setResolvedData(validData);
        } catch (error) {
            console.error('Error fetching resolved unstamp requests:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (activeTab === 'pending') {
            fetchPending();
        } else {
            fetchResolved();
        }
    }, [activeTab]);

    const activeData = activeTab === 'pending' ? pendingData : resolvedData;

    return (
        <div className='DataFeed'>
            {/* Feed */}
            {loading ? (
                <div className='UserFeed'>Loading...</div>
            ) : activeData.length > 0 ? (
                activeData.map((datum) => (
                    <DatumList
                        data={datum}
                        key={datum._id}
                        id={datum._id}
                        setMainContent={setMainContent}
                        datum_state='pubdatum'
                    />
                ))
            ) : (
                <div className='UserFeed'>
                    {activeTab === 'pending'
                        ? <div className='General-nr-container'>
                            <span className='General-nr-top'>You don't have any pending Unstamp Requests.</span>
                            <TbRubberStampOff size='30'/>
                            <div className='General-nr-hint'>If you want remove or make a change to a Datum that has already been stamped by a Group, click or tap the <TbRubberStampOff /> icon at the bottom of the Datum.  The Group(s) will be notified and the Datum will appear here.</div>
                        </div>
                        : <div className='General-nr-container'>
                            <span className='General-nr-top'>You don't have any Unstamped Data.</span>
                            <VscPassFilled size='30'/>
                            <div className='General-nr-hint'>After you make an Unstamp Request, the Datum will be found in the Unstamp Requests feed.  Once all Groups have unstamped, the Datum will appear here.</div>
                        </div>}
                </div>
            )}
        </div>
    );
};

export default UnstampFeed;